import React from 'react';

import { Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import action_library_messages from 'messages/action_library_messages';

import useStyles from './EmptyState.styles';

type Props = {
  onResetFilters: () => void;
};

const EmptyState: React.FC<Props> = ({ onResetFilters }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Typography className={styles.title} variant='h5'>
        {t(action_library_messages.empty_state.title)}
      </Typography>
      <Typography className={styles.description} variant='body1'>
        {t(action_library_messages.empty_state.description)}
      </Typography>
      <Button className={styles.button} color='primary' onClick={onResetFilters} variant='contained'>
        {t(action_library_messages.empty_state.reset_filters)}
      </Button>
    </div>
  );
};

export default EmptyState;
